import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  key: 0,
  style: {
    "color": "red",
    "font-size": "20px",
    "text-align": "center"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $props.isShowCountDown ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString($data.contentTxt), 1)) : _createCommentVNode("", true);
}